/* KL doradca "Dobierz lampe" (27.10.2026, kopia motywu demo).
   Kroki: pom -> typ -> styl -> kolor -> budzet -> wyniki. Parametry URL (opcjonalne): pom, typ, styl, kolor, budzet.
   Start od pierwszego kroku bez odpowiedzi; komplet = od razu wyniki. typ=szynowe -> lista konfiguratorow, typ=cameleon -> strona CAMELEON.
   Dane: /collections/<typ>?view=kl-doradca&sort_by=best-selling&filter.v.price.*&filter.p.m.custom.{pomieszczenie,styl,kolor_wiodacy}
   (od 27.10 filtry S&D Pomieszczenie i Styl wlaczone - licznik pelny z Shopify). Fallback: brak filtra w kolekcji ->
   kryterium sprawdzane tutaj na do 4 stronach po 250 najczesciej kupowanych. */
(function () {
  var root = document.querySelector('[data-kld]');
  if (!root) return;

  var KROKI = ['pom', 'typ', 'styl', 'kolor', 'budzet'];
  var POKOJE = {
    'salon': ['salon'], 'sypialnia': ['sypialnia'], 'kuchnia': ['kuchnia'], 'jadalnia': ['jadalnia'],
    'lazienka': ['łazienka', 'lazienka'], 'korytarz': ['korytarz', 'schody', 'przedpokój'],
    'pokoj-dzieciecy': ['pokój dziecięcy', 'pokoj dzieciecy'], 'biuro': ['biuro', 'gabinet'],
    'ogrod': ['ogród', 'ogrod', 'elewacja/taras', 'taras', 'elewacja']
  };
  var NAZWY_POKOI = { 'salon': 'Salon', 'sypialnia': 'Sypialnia', 'kuchnia': 'Kuchnia', 'jadalnia': 'Jadalnia', 'lazienka': 'Łazienka',
    'korytarz': 'Korytarz i schody', 'pokoj-dzieciecy': 'Pokój dziecięcy', 'biuro': 'Biuro i gabinet', 'ogrod': 'Ogród i taras' };
  var ZEW = ['lampy-scienne-1', 'lampy-sufitowe-1', 'lampy-stojace', 'lampy-gruntowe', 'naswietlacze', 'oprawy-liniowe-zewnetrzne', 'oswietlenie-zewnetrzne'];
  /* runda 3 (27.10): ogrod = tylko kolekcje zewnetrzne + IP44+ (bez filtra pomieszczenia - kolekcja zewn. wystarcza);
     lazienka = typy wewnetrzne + domyslnie IP44+ (strefa mokra, wylaczane ?ip=0); pokoje wewnetrzne = bez produktow z tagiem zewnetrznym */
  var IP_MIN = 44;
  function ipNum(v) {
    var m = String(v || '').toUpperCase().match(/IP\s*X?(\d)(\d)/g);
    if (!m) return 0;
    return Math.min.apply(null, m.map(function (x) { var d = x.replace(/\D/g, ''); return parseInt(d.slice(-2), 10) || 0; }));
  }
  function typZewnetrzny(t) { return ZEW.indexOf(t) >= 0; }
  function typPasuje() {
    if (!stan.pom || !stan.typ) return true;
    if (stan.pom === 'ogrod') return typZewnetrzny(stan.typ);
    return !typZewnetrzny(stan.typ);
  }
  function ipWymagane() { return stan.pom === 'ogrod' || (stan.pom === 'lazienka' && stan.ip !== '0'); }
  /* grupy kolorow: slowa kluczowe, wygrywa slowo, ktore stoi NAJWCZESNIEJ w nazwie (np. "beżowy + złoty" = drewno/beże) */
  var KOLORY = {
    czarny: ['czarn', 'black', 'grafit', 'antracyt', 'onyx'],
    bialy: ['biał', 'bial', 'white', 'krem', 'ecru', 'mleczn', 'opal', 'transparent', 'przezrocz'],
    zloty: ['złot', 'zlot', 'gold', 'mosiądz', 'mosiadz', 'brass', 'miedź', 'miedz', 'bursztyn', 'brąz', 'braz'],
    szary: ['szar', 'srebr', 'chrom', 'nikiel', 'silver', 'grey', 'gray', 'aluminium', 'dymn', 'dymi'],
    drewno: ['drewn', 'natural', 'wood', 'beż', 'bez', 'orzech', 'dąb', 'dab', 'rattan', 'bambus', 'juta']
  };
  var NAZWY_KOLOROW = { czarny: 'Czarny i grafit', bialy: 'Biały i kremowy', zloty: 'Złoty, mosiądz, miedź', szary: 'Szary, srebrny, chrom', drewno: 'Drewno i beże', inne: 'Kolorowy', dowolny: 'Dowolny kolor' };
  var BUDZETY = { 'do300': [0, 300], '300-700': [300, 700], '700-1500': [700, 1500], '1500+': [1500, null], 'dowolny': [null, null] };
  var NAZWY_BUDZETOW = { 'do300': 'do 300 zł', '300-700': '300-700 zł', '700-1500': '700-1500 zł', '1500+': 'powyżej 1500 zł', 'dowolny': 'Bez limitu' };
  var ALIAS_BUDZET = { 'do-300': 'do300', '0-300': 'do300', '300': 'do300', '1500': '1500+', '1500-': '1500+', 'powyzej-1500': '1500+', '1500plus': '1500+', 'bez-limitu': 'dowolny' };
  var ALIAS_KOLOR = { 'zloty-mosiadz': 'zloty', 'mosiadz': 'zloty', 'szary-srebrny': 'szary', 'srebrny': 'szary', 'kolorowy': 'inne', 'grafit': 'czarny' };
  var ALIAS_TYP = { 'wiszace': 'lampy-wiszace', 'wiszaca': 'lampy-wiszace', 'sufitowe': 'plafony', 'plafon': 'plafony', 'kinkiet': 'kinkiety',
    'stojace': 'lampy-podlogowe', 'stojaca': 'lampy-podlogowe', 'podlogowe': 'lampy-podlogowe', 'stolowe': 'lampy-stolowe', 'stolowa': 'lampy-stolowe',
    'spoty': 'reflektorki-i-spoty', 'reflektorki': 'reflektorki-i-spoty', 'system-cameleon': 'cameleon', 'systemy-szynowe': 'szynowe' };
  var IKONY = {
    'salon': '<path d="M4 13v-2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2"/><path d="M3 13h18v4H3z"/><path d="M5 17v2M19 17v2"/>',
    'sypialnia': '<path d="M3 18V8"/><path d="M3 14h18v4"/><path d="M21 18v-5a3 3 0 0 0-3-3h-7v4"/><circle cx="7" cy="11" r="1.6"/>',
    'kuchnia': '<path d="M4 10h16v10H4z"/><path d="M4 14h16"/><path d="M9 6c0-1 1-2 3-2s3 1 3 2v4H9z"/>',
    'jadalnia': '<path d="M12 3v4"/><path d="M8 7h8l-1.5 3h-5z"/><path d="M4 16h16"/><path d="M6 16v4M18 16v4"/>',
    'lazienka': '<path d="M4 12h16v3a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"/><path d="M6 12V6a2 2 0 0 1 4 0"/><path d="M7 19l-1 2M17 19l1 2"/>',
    'korytarz': '<path d="M6 21V4h12v17"/><path d="M3 21h18"/><circle cx="14.5" cy="13" r=".9"/>',
    'pokoj-dzieciecy': '<path d="M12 4l2.2 4.6 5 .7-3.6 3.5.9 5-4.5-2.4-4.5 2.4.9-5L4.8 9.3l5-.7z"/>',
    'biuro': '<path d="M3 11h18"/><path d="M5 11v9M19 11v9"/><path d="M8 11l2-6h4"/><circle cx="15" cy="5" r="1.5"/>',
    'ogrod': '<path d="M12 21v-7"/><path d="M12 14c-4 0-6-3-6-6 3 0 6 2 6 6z"/><path d="M12 12c0-4 2-7 6-7 0 4-2 7-6 7z"/><path d="M5 21h14"/>'
  };

  var stan = {}; var historia = []; var krokTeraz = null; var ostatniWynik = null;
  var sekcje = {};
  root.querySelectorAll('[data-step]').forEach(function (s) { sekcje[s.dataset.step] = s; });
  var elBar = root.querySelector('[data-kld-bar]');
  var elKrok = root.querySelector('[data-kld-krok]');
  var elBack = root.querySelector('[data-kld-back]');
  var elWyb = root.querySelector('[data-kld-wybory]');
  var elInfo = root.querySelector('[data-kld-info]');
  var elLista = root.querySelector('[data-kld-lista]');
  var elWszystkie = root.querySelector('[data-kld-wszystkie]');

  root.querySelectorAll('[data-kld-ikona]').forEach(function (el) {
    var p = IKONY[el.dataset.kldIkona];
    if (p) el.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' + p + '</svg>';
  });

  function bez(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ł/g, 'l'); }
  function cena(gr) { return (gr / 100).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zł'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* --- odczyt URL --- */
  function czytajUrl() {
    var q = new URLSearchParams(location.search);
    var pom = q.get('pom'), typ = q.get('typ'), styl = q.get('styl'), kolor = q.get('kolor'), budzet = q.get('budzet');
    if (pom) { pom = bez(pom).replace(/\s+/g, '-'); if (pom === 'taras' || pom === 'elewacja-taras') pom = 'ogrod'; if (POKOJE[pom]) stan.pom = pom; }
    if (typ) { typ = bez(typ); stan.typ = ALIAS_TYP[typ] || typ; }
    if (styl) { styl = bez(styl).replace(/\s+/g, '-'); stan.styl = styl; }
    if (kolor) { kolor = bez(kolor); kolor = ALIAS_KOLOR[kolor] || kolor; if (NAZWY_KOLOROW[kolor]) stan.kolor = kolor; }
    if (budzet) { budzet = bez(budzet).replace(/\s|zl/g, ''); budzet = ALIAS_BUDZET[budzet] || budzet; if (BUDZETY[budzet]) stan.budzet = budzet; }
    if (q.get('ip') === '0') stan.ip = '0';
    sprawdzTyp();
  }
  /* typ lampy z linku (np. kafel kolekcji lamp wiszacych) nie pasuje do pomieszczenia -> pytamy o typ jeszcze raz */
  var nota = '';
  function sprawdzTyp() {
    if (!typPasuje()) {
      nota = stan.pom === 'ogrod'
        ? 'Do ogrodu i na taras pokazujemy tylko lampy zewnętrzne (IP44 lub wyższe). Wybierz typ lampy zewnętrznej.'
        : 'Ten typ lampy jest przeznaczony na zewnątrz. Wybierz lampę do wnętrza.';
      delete stan.typ;
    }
  }
  function zapiszUrl() {
    var q = new URLSearchParams(location.search);
    KROKI.forEach(function (k) { if (stan[k]) q.set(k, stan[k]); else q.delete(k); });
    if (stan.ip === '0' && stan.pom === 'lazienka') q.set('ip', '0'); else q.delete('ip');
    var s = q.toString();
    history.replaceState(null, '', location.pathname + (s ? '?' + s : ''));
  }

  function nazwaTypu(v) {
    var b = root.querySelector('[data-step="typ"] [data-val="' + CSS.escape(v) + '"]');
    if (b) return b.dataset.nazwa;
    return 'Z kolekcji: ' + v.replace(/-/g, ' ');
  }
  function nazwaStylu(v) {
    var b = root.querySelector('[data-step="styl"] [data-val="' + CSS.escape(v) + '"]');
    return b ? b.dataset.nazwa : v;
  }
  function etykieta(k, v) {
    if (k === 'pom') return NAZWY_POKOI[v] || v;
    if (k === 'typ') return nazwaTypu(v);
    if (k === 'styl') return v === 'dowolny' ? 'Dowolny styl' : nazwaStylu(v);
    if (k === 'kolor') return NAZWY_KOLOROW[v] || v;
    if (k === 'budzet') return NAZWY_BUDZETOW[v] || v;
    return v;
  }

  function pierwszyBrak() {
    for (var i = 0; i < KROKI.length; i++) {
      var k = KROKI[i];
      if (k !== 'typ' && (stan.typ === 'szynowe' || stan.typ === 'cameleon')) break;
      if (!stan[k]) return k;
    }
    return null;
  }

  function pokaz(krok, wDol) {
    if (krok == null) {
      if (stan.typ === 'szynowe') krok = 'szynowe';
      else if (stan.typ === 'cameleon') { location.href = '/pages/skompletuj-lampe-cameleon'; return; }
      else krok = 'wyniki';
    }
    if (wDol && krokTeraz && krokTeraz !== krok) historia.push(krokTeraz);
    krokTeraz = krok;
    root.classList.toggle('kld--dalej', krok !== 'pom');
    Object.keys(sekcje).forEach(function (k) { sekcje[k].hidden = k !== krok; });
    if (krok === 'typ') {
      var zew = stan.pom === 'ogrod';
      root.querySelector('[data-kld-typy="wew"]').hidden = zew;
      root.querySelector('[data-kld-typy="zew"]').hidden = !zew;
      var en = root.querySelector('[data-kld-nota]');
      if (en) { en.textContent = nota; en.hidden = !nota; }
      nota = '';
    }
    /* zaznaczenie wybranej odpowiedzi */
    if (sekcje[krok]) sekcje[krok].querySelectorAll('.kld__opt[data-val]').forEach(function (b) {
      var on = stan[krok] === b.dataset.val;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var idx = KROKI.indexOf(krok);
    var proc = krok === 'wyniki' || krok === 'szynowe' ? 100 : Math.round(idx / KROKI.length * 100);
    elBar.style.width = proc + '%';
    elKrok.textContent = idx >= 0 ? 'Krok ' + (idx + 1) + ' z ' + KROKI.length : (krok === 'szynowe' ? 'Konfiguratory szynowe' : 'Twoje wyniki');
    elBack.hidden = historia.length === 0 && idx <= 0;
    rysujWybory();
    zapiszUrl();
    if (krok === 'wyniki') szukaj();
    var top = root.querySelector('.kld__bar').getBoundingClientRect().top + scrollY - 90;
    if (wDol && scrollY > top) scrollTo({ top: top, behavior: 'smooth' });
  }

  function rysujWybory() {
    var h = '';
    KROKI.forEach(function (k) {
      if (!stan[k]) return;
      h += '<button type="button" class="kld__chip" data-zmien="' + k + '" aria-label="Zmień: ' + esc(etykieta(k, stan[k])) + '">' + esc(etykieta(k, stan[k])) +
        ' <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 20h4L19 9l-4-4L4 16z"/></svg></button>';
    });
    elWyb.innerHTML = h;
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('.kld__opt[data-val]');
    if (b && sekcje[krokTeraz] && sekcje[krokTeraz].contains(b)) {
      var k = krokTeraz;
      stan[k] = b.dataset.val;
      if (k === 'pom') { /* zmiana wew./zew. kasuje niepasujacy typ */
        var zew = stan.pom === 'ogrod';
        if (stan.typ && !typPasuje()) delete stan.typ;
      }
      if (k === 'typ' && b.dataset.val === 'cameleon') { zapiszUrl(); location.href = '/pages/skompletuj-lampe-cameleon'; return; }
      pokaz(pierwszyBrak(), true);
      return;
    }
    var z = e.target.closest('[data-zmien]');
    if (z) { pokaz(z.dataset.zmien, true); return; }
    if (e.target.closest('[data-kld-back]')) {
      var poprz = historia.pop();
      if (!poprz) { var i = KROKI.indexOf(krokTeraz); poprz = i > 0 ? KROKI[i - 1] : (krokTeraz === 'wyniki' || krokTeraz === 'szynowe' ? 'budzet' : 'pom'); if (krokTeraz === 'szynowe') poprz = 'typ'; }
      pokaz(poprz, false);
      return;
    }
    if (e.target.closest('[data-kld-reset]')) { stan = {}; historia = []; pokaz('pom', false); }
  });
  root.addEventListener('change', function (e) {
    if (!e.target.matches('[data-kld-ip]')) return;
    if (e.target.checked) delete stan.ip; else stan.ip = '0';
    zapiszUrl(); szukaj();
  });

  /* --- wyniki --- */
  function grupaKoloru(k) {
    var s = bez(k); if (!s) return 'inne';
    var best = null, pos = 1e9;
    Object.keys(KOLORY).forEach(function (g) {
      KOLORY[g].forEach(function (w) { var i = s.indexOf(bez(w)); if (i >= 0 && i < pos) { pos = i; best = g; } });
    });
    return best || 'inne';
  }
  function pasujePokoj(p) {
    var lista = (p.pm || []).map(bez);
    return (POKOJE[stan.pom] || []).some(function (w) { return lista.indexOf(bez(w)) >= 0; });
  }
  function pasujeStyl(p) {
    if (!stan.styl || stan.styl === 'dowolny') return true;
    var cel = bez(stan.styl).replace(/-/g, ' ');
    return (p.st || []).some(function (s) { return bez(s) === cel; });
  }
  function pasujeKolor(p) {
    if (!stan.kolor || stan.kolor === 'dowolny') return true;
    return grupaKoloru(p.k) === stan.kolor;
  }

  /* --- od 27.10: filtry S&D Pomieszczenie i Styl wlaczone -> filtrowanie po stronie Shopify (pelny licznik).
     Wartosci bierzemy z "f" (dostepne wartosci filtrow w kolekcji typu). Gdy filtra w kolekcji nie ma (null) -
     kryterium sprawdzane w przegladarce na pobranych produktach (jak wczesniej). --- */
  var PF = { pom: 'filter.p.m.custom.pomieszczenie', styl: 'filter.p.m.custom.styl', kolor: 'filter.p.m.custom.kolor_wiodacy', ip: 'filter.p.m.custom.ip' };
  var FN = { pom: function (p) { return pasujePokoj(p); }, styl: function (p) { return pasujeStyl(p); }, kolor: function (p) { return pasujeKolor(p); },
    ip: function (p) { return ipNum(p.ip) >= IP_MIN; } };
  function aktywne(k) {
    if (k === 'ip') return ipWymagane();
    if (k === 'pom' && stan.pom === 'ogrod') return false; /* kolekcja zewnetrzna + IP zamiast metapola pomieszczenia */
    return !!stan[k] && stan[k] !== 'dowolny';
  }
  /* undefined = kryterium nieaktywne, null = brak filtra w kolekcji, [] = filtr jest, ale zadna wartosc nie pasuje */
  function wartosci(f, k) {
    if (!aktywne(k)) return undefined;
    var lst = f && f[PF[k]];
    if (!lst) return null;
    var ok;
    if (k === 'pom') { var cele = (POKOJE[stan.pom] || []).map(bez); ok = function (v) { return cele.indexOf(bez(v)) >= 0; }; }
    else if (k === 'styl') { var cel = bez(stan.styl).replace(/-/g, ' '); ok = function (v) { return bez(v) === cel; }; }
    else if (k === 'ip') ok = function (v) { return ipNum(v) >= IP_MIN; };
    else ok = function (v) { return grupaKoloru(v) === stan.kolor; };
    return lst.filter(function (x) { return ok(x.v); }).map(function (x) { return x.v; });
  }
  function parametry(serwer) {
    var q = new URLSearchParams();
    var b = BUDZETY[stan.budzet] || [null, null];
    if (b[0] != null) q.set('filter.v.price.gte', b[0]);
    if (b[1] != null) q.set('filter.v.price.lte', b[1]);
    Object.keys(serwer || {}).forEach(function (k) { serwer[k].forEach(function (v) { q.append(PF[k], v); }); });
    return q;
  }
  function adresDanych(strona, serwer) {
    var q = parametry(serwer);
    q.set('view', 'kl-doradca'); q.set('sort_by', 'best-selling'); q.set('page', strona);
    return '/collections/' + encodeURIComponent(stan.typ) + '?' + q.toString();
  }
  var pamiec = {};
  function pobierz(url, ms) {
    if (pamiec[url]) return Promise.resolve(pamiec[url]);
    var ctl = window.AbortController ? new AbortController() : null;
    var t = setTimeout(function () { if (ctl) ctl.abort(); }, ms);
    return fetch(url, { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
      .then(function (r) { clearTimeout(t); if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) { pamiec[url] = d; return d; });
  }
  /* pobiera 1 strone (albo do 4, gdy czesc kryteriow liczymy w przegladarce) */
  function pobierzZestaw(serwer, ileStron) {
    var lista = [], d1 = null, start = Date.now();
    function krok(n) {
      return pobierz(adresDanych(n, serwer), 12000).then(function (d) {
        if (!d1) d1 = d;
        lista = lista.concat(d.p || []);
        if (n < Math.min(d.pages, ileStron) && Date.now() - start < 15000) return krok(n + 1);
      });
    }
    return krok(1).then(function () { return { d: d1, lista: lista }; });
  }

  var zapytanie = 0;
  function szukaj() {
    var moje = ++zapytanie;
    elLista.innerHTML = '<p class="kld__ladowanie">Szukamy pasujących lamp...</p>';
    elInfo.textContent = '';
    pobierz(adresDanych(1, {}), 12000).then(function (meta) {
      if (moje !== zapytanie) return;
      var W = { pom: wartosci(meta.f, 'pom'), styl: wartosci(meta.f, 'styl'), kolor: wartosci(meta.f, 'kolor'), ip: wartosci(meta.f, 'ip') };
      /* kolejnosc luzowania: kolor -> styl -> pomieszczenie; IP44+ dla ogrodu nigdy nie jest luzowane, dla lazienki na samym koncu */
      var BAZA = [['pom', 'styl', 'kolor'], ['pom', 'styl'], ['pom', 'kolor'], ['pom'], ['kolor'], []];
      var ZESTAWY = BAZA;
      if (stan.pom === 'ogrod') ZESTAWY = BAZA.map(function (z) { return z.concat('ip'); });
      else if (ipWymagane()) ZESTAWY = BAZA.map(function (z) { return z.concat('ip'); }).concat([['pom', 'styl', 'kolor'], ['pom'], []]);
      var NAZWY = { pom: 'pomieszczenie', styl: 'styl', kolor: 'kolor', ip: 'szczelność IP44+' };
      var i = 0;
      function proba() {
        var zest = ZESTAWY[i];
        var akt = zest.filter(aktywne);
        var serwer = {}, klient = [], pusty = false;
        akt.forEach(function (k) {
          if (W[k] === null) klient.push(k);
          else if (!W[k].length) pusty = true;
          else serwer[k] = W[k];
        });
        var pominiete = ['pom', 'styl', 'kolor', 'ip'].filter(function (k) { return aktywne(k) && zest.indexOf(k) < 0; }).map(function (k) { return NAZWY[k]; });
        var ostatni = i === ZESTAWY.length - 1;
        if (pusty && !ostatni) { i++; return proba(); }
        return pobierzZestaw(serwer, klient.length ? 4 : 1).then(function (r) {
          if (moje !== zapytanie) return;
          var lista = klient.length ? r.lista.filter(function (p) { return klient.every(function (k) { return FN[k](p); }); }) : r.lista;
          var ile = klient.length ? lista.length : r.d.n;
          /* pokoje wewnetrzne: bez produktow oznaczonych jako zewnetrzne (pojedyncze produkty maja oba tagi) */
          if (stan.pom !== 'ogrod') { var przed = lista.length; lista = lista.filter(function (p) { return !p.z; }); if (!klient.length) ile -= (przed - lista.length); }
          if (ile >= 4 || ostatni) {
            pokazWyniki(lista, ile, r.d.t, { klient: klient, przejrzane: r.lista.length, pominiete: pominiete.join(', '), serwer: serwer, wKolekcji: meta.n });
          } else { i++; return proba(); }
        });
      }
      return proba();
    }).catch(function () {
      if (moje !== zapytanie) return;
      elLista.innerHTML = '<p class="kld__ladowanie">Nie udało się pobrać produktów. Spróbuj ponownie za chwilę albo zobacz całą kolekcję.</p>';
      ustawLink('', {});
    });
  }

  function pokazWyniki(wynik, ile, tytul, o) {
    var dostepne = wynik.filter(function (p) { return p.a; });
    var pokazane = dostepne.concat(wynik.filter(function (p) { return !p.a; })).slice(0, 12);
    ostatniWynik = wynik;
    var info = 'Pasuje <b>' + ile + '</b> ' + (ile === 1 ? 'lampa' : 'lamp') + ' w kolekcji „' + esc(tytul) + '”' + (stan.budzet && stan.budzet !== 'dowolny' ? ' w tym budżecie' : '') + '.';
    if (o.klient.length) info += '<span class="kld__uwaga">Część kryteriów sprawdzona na ' + o.przejrzane + ' najczęściej kupowanych (w tej kolekcji brak filtra).</span>';
    if (o.pominiete) info += '<span class="kld__uwaga">Dokładnie pasujących było mniej niż 4, więc pominęliśmy kryterium: ' + o.pominiete + '.</span>';
    if (stan.pom === 'ogrod') info += '<span class="kld__uwaga">Tylko oprawy zewnętrzne o szczelności IP44 lub wyższej.</span>';
    if (!ile) info = 'Nie znaleźliśmy lampy dla tych odpowiedzi. Zmień budżet albo zobacz całą kolekcję.';
    if (stan.pom === 'lazienka') info += '<label class="kld__ip"><input type="checkbox" data-kld-ip' + (stan.ip === '0' ? '' : ' checked') + '> Tylko do strefy mokrej (IP44 lub wyższe)</label>';
    elInfo.innerHTML = info;
    elLista.innerHTML = pokazane.map(karta).join('');
    ustawLink(tytul, o.serwer);
  }

  function karta(p) {
    var promo = p.cc > p.c;
    var proc = promo ? Math.round((p.cc - p.c) / p.cc * 100) : 0;
    var img = p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="400" height="400">' : '';
    var omni = '';
    if (promo && p.o != null && p.o !== '') { var o = parseFloat(String(p.o).replace(',', '.')); if (o > 0) omni = '<span class="kld__p-o">Najniższa z 30 dni: ' + cena(Math.round(o * 100)) + '</span>'; }
    return '<a class="kld__p" href="/products/' + encodeURIComponent(p.h) + '">' +
      '<span class="kld__p-img">' + img + (promo ? '<span class="kld__p-odz">-' + proc + '%</span>' : '') + '</span>' +
      '<span class="kld__p-b"><span class="kld__p-m">' + esc(p.b) + '</span><span class="kld__p-t">' + esc(p.t) + '</span>' +
      '<span class="kld__p-c"><strong>' + cena(p.c) + '</strong>' + (promo ? '<s>' + cena(p.cc) + '</s>' : '') + '</span>' + omni +
      (p.a ? '' : '<span class="kld__p-o">Chwilowo niedostępna</span>') + '</span></a>';
  }

  /* link do kolekcji: te same filtry S&D co wyniki (cena, pomieszczenie, styl, kolor) */
  function ustawLink(tytul, serwer) {
    var s = parametry(serwer).toString();
    elWszystkie.href = '/collections/' + encodeURIComponent(stan.typ) + (s ? '?' + s : '');
    elWszystkie.textContent = 'Zobacz wszystkie w kolekcji' + (tytul ? ' „' + tytul + '”' : '');
  }

  czytajUrl();
  pokaz(pierwszyBrak(), false);
})();
